import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, Transition as _Transition, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative gap-5 lg:col-span-2 lg:col-start-2 lg:row-start-1 lg:-ml-12 lg:grid lg:grid-cols-4 lg:grid-rows-2 lg:self-start" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "mt-2 pl-14" }
const _hoisted_5 = ["href", "target"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("template", null, null, -1)
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 0,
  class: "flex items-center lg:pointer-events-none lg:absolute lg:top-0 lg:left-0 lg:z-0 lg:block lg:h-0 lg:w-full lg:pt-1/1"
}
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "relative font-light lg:hidden" }
const _hoisted_11 = { class: "relative hidden font-light lg:inline" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "absolute bottom-0 left-0 hidden w-full scale-0 transition-transform duration-300 lg:block lg:w-0 lg:border-b-2 lg:border-gray-500 lg:group-hover:w-full lg:group-hover:scale-100" }, null, -1)
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "relative h-0 pt-1/1" }
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = {
  key: 1,
  class: "relative font-light"
}
const _hoisted_17 = {
  key: 2,
  class: "mb-10 text-lg"
}
const _hoisted_18 = { class: "grid w-2/3 grid-cols-2 grid-rows-5 gap-y-6 gap-x-9" }
const _hoisted_19 = ["href", "target"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "absolute bottom-0 left-0 w-full origin-left scale-0 transition-transform duration-300 lg:border-b-2 lg:border-gray-500 lg:group-1-hover:scale-100" }, null, -1)
const _hoisted_21 = {
  key: 4,
  class: "absolute bottom-0 left-0 w-full scale-0 transition-transform duration-300 lg:border-b-2 lg:border-gray-500 lg:group-hover:scale-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_biz_accordion = _resolveComponent("biz-accordion")!
  const _component_biz_icon = _resolveComponent("biz-icon")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item._uid,
        class: _normalizeClass(["relative", {
                ..._ctx.inactiveClass(i),
                'lg:col-span-2 lg:row-span-2 lg:h-0 lg:pt-1/1': i === 0
            }])
      }, [
        (item.subItems.length)
          ? (_openBlock(), _createBlock(_component_biz_accordion, {
              key: 0,
              class: "py-4 lg:hidden",
              group: "product-category"
            }, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("img", {
                    src: item.image,
                    alt: item.imageAlt,
                    class: "mr-3 h-12 w-12 shrink-0 object-contain object-center"
                  }, null, 8, _hoisted_3),
                  _createElementVNode("span", null, _toDisplayString(item.title), 1)
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("ul", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subItems, (subItem) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: subItem._uid,
                      class: "ml-1"
                    }, [
                      _createElementVNode("a", {
                        href: subItem.link,
                        target: subItem.target,
                        class: "group relative flex h-full items-center pb-3 font-light"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(subItem.title), 1)
                      ], 8, _hoisted_5)
                    ]))
                  }), 128))
                ]),
                _hoisted_6
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (item.subItems.length === 0 && item.link.length > 0)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: item.link,
              class: "group mb-4 flex items-center justify-between border-b border-gray-400/30 py-2 lg:absolute lg:left-0 lg:top-0 lg:mb-0 lg:min-h-full lg:w-full lg:items-end lg:justify-center lg:overflow-hidden lg:border-0 lg:bg-gray-200 lg:p-6"
            }, [
              (item.image)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: item.image,
                      alt: item.imageAlt,
                      class: "mr-3 h-12 w-12 shrink-0 object-contain object-center lg:absolute lg:left-0 lg:top-0 lg:h-full lg:w-full"
                    }, null, 8, _hoisted_9),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(item.title), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, _toDisplayString(item.title), 1),
              _hoisted_12,
              _createVNode(_component_biz_icon, {
                name: "chevron-right",
                class: "h-3 w-3 shrink-0 fill-current lg:hidden"
              })
            ], 8, _hoisted_7))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["group absolute left-0 top-0 hidden min-h-full w-full overflow-hidden bg-gray-200", [
                    { 'cursor-pointer': item.subItems.length > 0 },
                    _ctx.activeItem === i ? 'p-12 lg:block' : 'items-end justify-center p-6 lg:flex'
                ]]),
              onClick: _withModifiers(($event: any) => (_ctx.onItemClick(item, i, $event)), ["stop"])
            }, [
              (item.image)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["pointer-events-none absolute top-0 z-0 transition-all", [
                        item.subItems.length > 0 ? 'w-[393px]' : 'h-full w-full',
                        _ctx.activeItem === i
                            ? 'left-full -translate-x-2/3 translate-y-16'
                            : 'left-0 delay-300'
                    ]])
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("img", {
                        src: item.image,
                        alt: item.imageAlt,
                        class: "absolute left-0 top-0 h-full w-full object-contain object-center"
                      }, null, 8, _hoisted_15)
                    ])
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.activeItem !== i)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(item.title), 1))
                : _createCommentVNode("", true),
              (_ctx.activeItem === i)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(item.title), 1))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_Transition, {
                "enter-active-class": "duration-300 ease-out delay-300",
                "enter-from-class": "opacity-0",
                "enter-to-class": "opacity-100",
                "leave-active-class": "duration-300 ease-out delay-0",
                "leave-from-class": "opacity-100",
                "leave-to-class": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subItems, (subItem) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: subItem._uid,
                        class: "border-b border-gray-100"
                      }, [
                        _createElementVNode("a", {
                          href: subItem.link,
                          target: subItem.target,
                          class: "group-1 relative flex h-full items-center pb-3 font-light"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(subItem.title), 1),
                          _hoisted_20
                        ], 8, _hoisted_19)
                      ]))
                    }), 128))
                  ])
                ]),
                _: 2
              }, 1536), [
                [_vShow, _ctx.activeItem === i]
              ]),
              (_ctx.activeItem === i)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: "absolute top-4 right-4 h-5 w-5 cursor-pointer",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["stop"]))
                  }, [
                    _createVNode(_component_biz_icon, {
                      name: "close",
                      class: "h-full w-full text-gray-400"
                    })
                  ]))
                : _createCommentVNode("", true),
              (item.subItems.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21))
                : _createCommentVNode("", true)
            ], 10, _hoisted_13))
      ], 2))
    }), 128))
  ], 512)), [
    [_vShow, _ctx.show]
  ])
}